import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
var SAR = function SAR(_ref) {
  var className = _ref.className;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("span", {
    className: twMerge(className)
  }, t("ريال", {
    ns: "web_common"
  }));
};
export default SAR;